import React from 'react'
import Head from "next/head";
import Heineken from '@/components/casestudy/Heineken';

const heineken = () => {
    return (
        <>
            <Head>
                <title>Heineken Case Study: Optimizing Brewery Operations</title>
                <link rel="canonical" href="https://queuebuster.co/casestudy/heineken" />
                <link rel="alternate" href="https://queuebuster.co/casestudy/heineken" hrefLang="en-us" />
                <meta name="description" content="Implemented across 314 Heineken-owned breweries in Nigeria, QueueBuster transformed billing and inventory management, automating processes and ensuring seamless" />
                <meta property="og:title" content="Heineken’s Operational Transformation with QueueBuster POS" />
                <meta property="og:description" content="Discover how Heineken implemented QueueBuster POS across 314 breweries in Nigeria to automate billing and inventory management. Learn how our solution met Heineken’s requirements, seamless operations, sales accuracy, and optimized inventory control." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/eyeglasses-3184405.png" />
                <meta property="og:url" content="https://queuebuster.co/casestudy/heineken" />
            </Head>
            <Heineken />
        </>
    )
}

export default heineken